module.exports = __webpack_public_path__ + "static/project-21c-6d1676375e5833cd3a9a10d3267a5694.png";